import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import { selectLoggedIn } from "../store/slices/auth/slice";

const ProtectedRoute = () => {
  const isLoggedIn = useSelector(selectLoggedIn);

  return isLoggedIn ? <Outlet /> : <Navigate to="/" replace />;
};

export default ProtectedRoute;
